import React from "react"
import PropTypes from "prop-types"
import { BsChevronRight } from "react-icons/bs"
import { Link } from "gatsby"

export default function Button({
  buttonText,
  buttonLink,
  buttonColor,
  className,
}) {
  return (
    <div className="inline-block">
      <Link
        to={buttonLink}
        className={`${buttonColor} ${className} py-3 px-8 font-playfaird tracking-wider uppercase flex items-center justify-center rounded-sm whitespace-nowrap`}
      >
        <span>{buttonText}</span>
        <BsChevronRight className="ml-2 h-4" />
      </Link>
    </div>
  )
}

Button.propTypes = {
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
  buttonColor: PropTypes.string,
}

Button.defaultProps = {
  buttonText: `Book Now`,
  buttonLink: "/",
  buttonColor: "bg-amber-200 text-slate-900",
}
